// Look shared by the order pop-up edit forms (tracking, address).

export const FORM_STYLE = {
  gridColumn: '1 / -1',
  background: 'var(--color-bg-secondary)',
  border: '1px solid var(--color-border)',
  borderRadius: 8,
  padding: 16
}
export const NOTICE_STYLE = {
  gridColumn: '1 / -1',
  padding: 'var(--space-2) var(--space-3)',
  borderRadius: 6,
  fontSize: '0.8rem'
}
export const ERROR_STYLE = {
  ...NOTICE_STYLE,
  background: 'var(--color-error-bg, #fdecea)',
  color: 'var(--color-error, #b71c1c)',
  border: '1px solid var(--color-error, #b71c1c)'
}
export const SUCCESS_STYLE = {
  ...NOTICE_STYLE,
  background: 'var(--color-success-bg, #e8f5ee)',
  border: '1px solid var(--color-success, #2e9e6b)'
}
